import React from 'react';
import { Link } from 'react-router-dom';

const FixedButtons: React.FC = () => {
  return (
    <div className="fixed-buttons" role="navigation" aria-label="Quick actions">
      <Link to="/become-member/" className="fixed-btn member-btn fixed-btn-member" aria-label="Join as member">
        <i className="fas fa-user-plus" aria-hidden="true"></i>
        <span className="btn-text">Join as Member</span>
      </Link>
      <Link to="/volunteer/" className="fixed-btn volunteer-btn fixed-btn-volunteer" aria-label="Volunteer with us">
        <i className="fas fa-hands-helping" aria-hidden="true"></i>
        <span className="btn-text">Volunteer</span>
      </Link>
      <Link to="/donate/" className="fixed-btn donate-btn fixed-btn-donate" aria-label="Donate now">
        <i className="fas fa-donate" aria-hidden="true"></i>
        <span className="btn-text">Donate Now</span>
      </Link>
    </div>
  );
};

export default FixedButtons;
